import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

export default function Card({ children, className = '', hover = false, padding = 'md' }: CardProps) {
  const paddingClass = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  }[padding];

  return (
    <div
      className={`
        bg-rs-surface border border-rs-border rounded-xl shadow-card
        transition-all duration-300
        ${hover ? 'hover:shadow-card-hover hover:border-rs-accent/40 hover:-translate-y-1' : ''}
        ${paddingClass}
        ${className}
      `}
    >
      {children}
    </div>
  );
}
